"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = "https://github.com/formly-js/angular-formly/blob/" + VERSION + "/other/ERRORS_AND_WARNINGS.md#";
module.exports = exports["default"];


/** WEBPACK FOOTER **
 ** ./other/docsBaseUrl.js
 **/